import { TEC_DIREZIONE_LAVORI } from 'constants/ProjectsConstant';
import { GENERIC_TASKS, TECHNICIAN_TASKS } from './CommonTasks';

export const TEC_DIREZIONE_LAVORI_STEPS = [
  {
    code: TEC_DIREZIONE_LAVORI,
    icon: null,
    order: 1,
  },
];

export const TEC_DIREZIONE_LAVORI_TASKS = [...TECHNICIAN_TASKS, ...GENERIC_TASKS];
